(() => {
  const elementName = 'cc-t10-eversolo-control-carousel';

  if (customElements.get(elementName)) return;

  class CcT10EversoloControlCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.image = this.querySelector('[data-cc-t10-eversolo-control-image]');
      this.mobileSource = this.querySelector('[data-cc-t10-eversolo-control-mobile-source]');
      this.previousButton = this.querySelector('[data-cc-t10-eversolo-control-previous]');
      this.nextButton = this.querySelector('[data-cc-t10-eversolo-control-next]');
      this.sourceTemplate = this.querySelector('[data-cc-t10-eversolo-control-sources]');
      this.sources = this.parseSources();
      this.currentIndex = 0;

      if (!this.image || !this.mobileSource || !this.previousButton || !this.nextButton || this.sources.length !== 3) return;

      this.previousButton.addEventListener('click', () => this.setCurrentIndex(this.currentIndex - 1), { signal: this.controller.signal });
      this.nextButton.addEventListener('click', () => this.setCurrentIndex(this.currentIndex + 1), { signal: this.controller.signal });

      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.mediaQuery.addEventListener('change', this.handleBreakpointChange, { signal: this.controller.signal });
      this.render();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    parseSources() {
      return this.sourceTemplate?.content.textContent.trim().split('|').map((record) => {
        const [mobile, desktop, alt] = record.trim().split('~');
        return { mobile, desktop, alt };
      }).filter((record) => record.mobile && record.desktop && record.alt) || [];
    }

    handleBreakpointChange = () => this.render();

    setCurrentIndex(nextIndex) {
      this.currentIndex = (nextIndex + 3) % 3;
      this.render();
    }

    render() {
      const source = this.sources[this.currentIndex];
      if (!source) return;

      this.mobileSource.srcset = source.mobile;
      this.image.src = source.desktop;
      this.image.alt = source.alt;

      if (this.mediaQuery?.matches) {
        this.image.width = 860;
        this.image.height = 1317;
      } else {
        this.image.width = 3840;
        this.image.height = 2160;
      }
    }
  }

  customElements.define(elementName, CcT10EversoloControlCarousel);
})();
